// extracted by mini-css-extract-plugin
module.exports = {"icon":"a10a3f92e9--icon--rfrwK"};